if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
      }
      
      setActiveMedia(mediaId, prepend) {
        // Extract numeric ID from full ID string (e.g., 'template--123__main-456' -> '456')
        const numericId = mediaId.split('-').pop();
        
        // Find the media item with the matching data-media-id
        const mediaItems = this.querySelectorAll('[data-media-id]');
        const targetMedia = Array.from(mediaItems).find(item => {
          return item.dataset.mediaId === numericId || 
                 item.dataset.mediaId === mediaId ||
                 item.dataset.mediaId === mediaId.toString();
        });
        
        if (!targetMedia) return;
        
        // If using Swiper carousel
        const swiper = this.querySelector('.swiper-main')?.swiper;
        if (swiper) {
          const slideIndex = Array.from(mediaItems).indexOf(targetMedia);
          if (slideIndex >= 0) {
            swiper.slideTo(slideIndex);
          }
          return;
        }
        
        // Fallback: scroll to the media item
        targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  );
}